import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { useFetchShiftByRegion } from 'hooks/useFetchShift';

import { Loader } from '../../../../components/Loader/Loader';

import '../Widget.scss';
import { ReqEnum } from '../../../../const/requestStatus';
import { DayBookedStatsForDashboardWidget } from 'pages/shift/WeekDayForAdmin/WeekDayForAdmin';
import { ShiftCourierJson } from '../../../../const/ShiftConst';
import { Link } from 'react-router-dom';
import { ButtonComponent } from '../../../../ReusableComponents/Button/ButtonComponent';
import { FaWrench } from 'react-icons/fa';
import analyticsWrapper from '../../../../utils/analyticsWrapper';
import { Region } from '../../../../types/orderTypes';

export default function CouriersWidget({
  region,
}: {
  region: Region;
}): JSX.Element {
  const startDate: Dayjs = dayjs(new Date());
  const endDate: Dayjs = dayjs(new Date()).add(1, 'day');

  const [ShiftCourierWithDateList, fetchStatus] = useFetchShiftByRegion(
    startDate,
    endDate,
    region
  );

  if (fetchStatus !== ReqEnum.SUCCESS) {
    return (
      <div className="widget">
        <div className="widget__header">
          <h5>Couriers</h5>
        </div>
        <div className="widget__loader">
          <Loader type="spinner" size="large" />
        </div>
      </div>
    );
  }

  const todayShifts: ShiftCourierJson[] =
    ShiftCourierWithDateList[0].courierDayBooked;
  const tomorowShifts: ShiftCourierJson[] =
    ShiftCourierWithDateList[1].courierDayBooked;

  return (
    <div className="widget">
      <div className="widget__header">
        <h5>Couriers (booked/planned)</h5>
      </div>

      <div className="widget__text">
        {' '}
        <span>Today:</span>{' '}
        <DayBookedStatsForDashboardWidget shiftCourierList={todayShifts} />
      </div>
      <div className="widget__text">
        <span>Tomorrow:</span>
        <DayBookedStatsForDashboardWidget shiftCourierList={tomorowShifts} />
      </div>
      <div className="widget__text">
        <ButtonComponent
          variant="outlined"
          startIcon={<FaWrench />}
          component={Link}
          to="/algo/courier-info"
          onClick={() => {
            analyticsWrapper.event({
              category: 'algo-info-courier-dashboard',
              action: `click-btn`,
              label: 'click',
            });
          }}
        >
          {'Area'}
        </ButtonComponent>
      </div>
    </div>
  );
}
